import { render, staticRenderFns } from "./receipt-bill.vue?vue&type=template&id=2115f2da&scoped=true"
import script from "./receipt-bill.vue?vue&type=script&lang=js"
export * from "./receipt-bill.vue?vue&type=script&lang=js"
import style0 from "./receipt-bill.vue?vue&type=style&index=0&id=2115f2da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115f2da",
  null
  
)

export default component.exports